export const styleSheet = (theme: any) => ({

});try {
    // @ts-ignore
    styleSheet.displayName = "styleSheet";
    // @ts-ignore
    styleSheet.__docgenInfo = { "description": "", "displayName": "styleSheet", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Label/styles.ts#styleSheet"] = { docgenInfo: styleSheet.__docgenInfo, name: "styleSheet", path: "src/shared/components/Label/styles.ts#styleSheet" };
}
catch (__react_docgen_typescript_loader_error) { }